import { useEffect } from "react";
import Lenis from "lenis";
import { Instagram } from "lucide-react";
import "@/App.css";
import { SquareBlocks } from "./components/SquareBlocks";
import { initAnalytics, captureUtmParams, trackEvent } from "./lib/analytics";
import { SITE_CONFIG } from "./data/stories";

const FooterBar = () => (
    <footer className="h-[52px] flex items-center justify-between gap-4 px-4 sm:px-6 bg-[#DCE6F2] border-t border-[#0B1220]/10" data-testid="site-footer">
        <span className="font-syne font-extrabold text-[#0B1220] text-sm tracking-tight" data-testid="footer-logo">
            FXTM<span className="text-fxtm-orange">.</span>
        </span>
        <p className="hidden sm:block font-mono text-[9px] tracking-[0.15em] text-slate-600 uppercase text-center" data-testid="footer-risk-line">
            Trading involves risk · *Bonus up to $500 — eligibility &amp; terms apply · © 2026 FXTM
        </p>
        <a
            href={SITE_CONFIG.instagramProfileUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("instagram_profile_click", { location: "footer" })}
            data-testid="footer-instagram-link"
            aria-label="FXTM Africa on Instagram"
            className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.18em] text-slate-600 hover:text-fxtm-orange transition-colors duration-300"
        >
            <Instagram className="w-3.5 h-3.5" />
            @FXTM_AFRICA
        </a>
    </footer>
);

function App() {
    useEffect(() => {
        initAnalytics();
        captureUtmParams();
        trackEvent("page_view");

        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="grain bg-[#E8EEF7] min-h-screen" data-testid="fxtm-landing-page">
            <main>
                <SquareBlocks />
            </main>
            <FooterBar />
        </div>
    );
}

export default App;
